import React, { useState, useContext } from "react";
import { Divider, Grid, Typography } from "@mui/material";
import Dropdown from "./selectClientPositionDropdown/ClientPositionDropdown";
import ClientSpecificView from "./clientSpecificView/ClientSpecificView";
import PositionSpecificView from "./positionSpecificView/PositionSpecificView";
import {
  funnelDataInitial,
  pieDataInitial,
  getPieEntry,
  mergeSources,
} from "../utils";
import DataContext from "../../context/DataContext";
import AuthContext from "../../context/AuthContext";
import { useEffect } from "react";

export default function ClientPositionArea() {
  let {
    clients,
    positions,
    setClientChecked,
    statsByClient,
    clientPieChartData,
    setClientPieChartData,
    clientData,
    setClientData,
    clientPositions,
    clientFunnelData,
    setClientFunnelData,
    clientPositionId,
    setClientPositions,
    setClientPositionId,
    clientId,
    clientName,
    setClientName,
    setClientId,
    clientChecked,
  } = useContext(DataContext);
  let { isAdmin, viewAsAdmin, setViewAsAdmin } = useContext(AuthContext);

  const [positionChecked, setPositionChecked] = React.useState(false);

  //position state
  const [posPieChartData, setPosPieChartData] = useState(pieDataInitial);
  const [posFunnelData, setPosFunnelData] = useState(funnelDataInitial);
  const [positionData, setPositionData] = useState({
    posATTH: null,
    posAV: null,
    posCPH: null,
    posCR: null,
    posTR: null,
    posTTR: null,
    posTTF: null,
    posName: null,
  });

  //move logic to datacontext
  const handleClientDropdownChange = (id) => {
    if (id in statsByClient) {
      setPositionChecked(false);
      setClientChecked(true);

      // setChecked((prev) => !prev); //was to supposed to do a collapse and rerender effect
      setClientFunnelData(statsByClient[id].funnel_data);
      setClientPieChartData(statsByClient[id].pieChartData);

      setClientData({
        vacancies: statsByClient[id].total_vacancies,
        totalPositions: statsByClient[id].total_positions,
        hiringCosts: statsByClient[id].total_hiring_costs,
      });
    } else {
      //client has no position data
      setClientData({
        vacancies: null,
        totalPositions: null,
        hiringCosts: null,
      });
      setClientFunnelData(funnelDataInitial);
      setClientPieChartData(pieDataInitial);
      //set position data to null
      setPositionChecked(false);
      // setClientChecked(false);
    }
  };

  const handlePositionDropdownChange = (id) => {
    setPositionChecked(true);
    // setChecked((prev) => !prev);
    var pos = clientPositions.filter((position) => position.id === id);
    var list_of_app_source = pos.map((a) => a.applicant_source);
    var pieChartData = Object.entries(mergeSources(list_of_app_source)).map(
      (a) => getPieEntry(a)
    );

    //bundle all of this into position data object
    setPositionData({
      posATTH: pos[0].avg_time_to_hire,
      posAV: pos[0].vacancies,
      posCPH: pos[0].cost_per_hire,
      posCR: pos[0].conversion_rate,
      posTR: pos[0].turnover_rate,
      posTTF: pos[0].time_to_fill,
      posName: pos[0].name,
    });

    setPosPieChartData(pieChartData);

    setPosFunnelData({
      //this data maybe null, funnel expects non null
      applications: pos[0].applications ?? 0,
      interviews: pos[0].interviews ?? 0,
      assessments: pos[0].assessments ?? 0,
      hires: pos[0].hires ?? 0,
    });
  };

  useEffect(() => {
    // console.log("useeffect in clientposarea", isAdmin);
    setPositionChecked(false);
    setClientPositionId(null);
    if (!isAdmin) {
      setClientChecked(true);
      try {
        if ("id" in clients[0]) {
          let id = clients[0].id;
          setClientFunnelData(statsByClient[id].funnel_data);
          setClientPieChartData(statsByClient[id].pieChartData);
          setClientData({
            vacancies: statsByClient[id].total_vacancies,
            totalPositions: statsByClient[id].total_positions,
            hiringCosts: statsByClient[id].total_hiring_costs,
          });
          setClientPositions(
            positions.filter((position) => position.client === id)
            // onSetClientCallback() //handles dopdown for positions
          );
          setClientName(clients[0].name);
        }
      } catch (e) {}
    } else {
      setClientChecked(false);
      setClientId(null);
      setClientPositions([]);
    }
  }, [isAdmin, clients, positions]);

  return (
    <div>
      <Typography color="#757575" variant="h4" sx={{ mx: 2 }}>
        {isAdmin ? "Client Dashboard" : "Dashboard"}
      </Typography>

      {/* If not admin show the below heading */}
      {!isAdmin ? (
        <Typography color="#757575" variant="h6" sx={{ ml: 2, mb: 2 }}>
          Client Name: {clientName}
        </Typography>
      ) : null}
      <Grid container rowSpacing={2} width={1}>
        {/* if admin show dropdown */}
        {isAdmin && (
          <Grid item sx={{ pb: 3 }}>
            <Dropdown
              clientPositions={clientPositions} //positions for specfic client
              setClientPositions={setClientPositions} //setter for the above
              clientId={clientId}
              setClientId={setClientId}
              clientPositionId={clientPositionId} //the position user selected to view
              setClientPositionId={setClientPositionId}
              handleClientDropdownChange={handleClientDropdownChange} //
              handlePositionDropdownChange={handlePositionDropdownChange}
            />
          </Grid>
        )}
        <Grid item sx={{ pb: 3 }}>
          <ClientSpecificView
            clientChecked={clientChecked}
            clientId={clientId}
            stats={statsByClient}
            data={clientData}
            clientPositions={clientPositions}
            clientFunnelData={clientFunnelData}
            clientPieChartData={clientPieChartData}
          />
          <Divider sx={{ mt: 4, background: "#757575" }} />
        </Grid>
        {!isAdmin && (
          <Grid item>
            <Dropdown
              clientPositions={clientPositions} //positions for specfic client
              setClientPositions={setClientPositions} //setter for the above
              clientId={clientId}
              setClientId={setClientId}
              clientPositionId={clientPositionId} //the position user selected to view
              setClientPositionId={setClientPositionId}
              handleClientDropdownChange={handleClientDropdownChange} //
              handlePositionDropdownChange={handlePositionDropdownChange}
            />
          </Grid>
        )}
        <Grid item>
          <PositionSpecificView
            positionChecked={positionChecked}
            posPieChartData={posPieChartData}
            posFunnelData={posFunnelData}
            data={positionData}
          />
        </Grid>
      </Grid>
    </div>
  );
}
